import { axiosInstance } from "../utils/axios";

// Inbox — { total, unreadCount, page, limit, data: [...] }
export const getNotificationsApi = async (page = 1, limit = 30) => {
  return await axiosInstance.get(
    `/notifications?page=${page}&limit=${limit}`
  );
};

// Mark a single notification read.
export const markNotificationReadApi = async (id) => {
  return await axiosInstance.patch(`/notifications/${id}/read`);
};

// Mark all read.
export const markAllNotificationsReadApi = async () => {
  return await axiosInstance.patch(`/notifications/read-all`);
};

// Register a Web Push (FCM) token so this browser receives background pushes.
export const registerDeviceTokenApi = async (token, platform = "web") => {
  return await axiosInstance.post(`/notifications/device/register`, {
    token,
    platform,
  });
};
